import type { Components, Theme } from '@mui/material';

export const MuiSwitch: Components<Theme>['MuiSwitch'] = {
  defaultProps: {
    disableRipple: true,
    focusVisibleClassName: '.Mui-focusVisible',
  },
  styleOverrides: {
    root: {
      width: 36,
      height: 20,
      padding: 0,
    },
    switchBase: ({ theme }) => ({
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: `translateX(${theme.spacing(2)})`,
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#84D300',
          opacity: 1,
          border: 0,
          ...theme.applyStyles('dark', {
            backgroundColor: '#84D300',
          }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
        ...theme.applyStyles('dark', {
          color: theme.palette.grey[600],
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
        ...theme.applyStyles('dark', {
          opacity: 0.3,
        }),
      },
    }),
    thumb: {
      boxSizing: 'border-box',
      width: 16,
      height: 16,
    },
    track: ({ theme }) => ({
      borderRadius: 20 / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      ...theme.applyStyles('dark', {
        backgroundColor: '#39393D',
      }),
    }),
  },
};
